import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { AppStateService } from "../services/app-state.service";


@Injectable()
export class AuthGuard  {

  constructor(private router: Router, private appState: AppStateService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.appState.user && this.appState.user.firstName) {
      return true;
    } else {
      this.router.navigate(["/public/login"], {
        queryParams: {
          return: state.url
        }
      });
      return false;
    }
  }
}
